export const fetchGithubProjects = async () => {
    const username = process.env.REACT_APP_GITHUB_USERNAME || 'k4ran909';
    const token = process.env.REACT_APP_GITHUB_TOKEN;

    const headers = {
        'Accept': 'application/vnd.github.v3+json'
    };

    if (token) {
        headers['Authorization'] = `token ${token}`;
    }

    try {
        const response = await fetch(`https://api.github.com/users/${username}/starred?sort=updated&direction=desc`, { headers });

        if (!response.ok) {
            throw new Error(`GitHub API error: ${response.statusText}`);
        }

        const data = await response.json();

        // Filter out forked repositories if you only want original projects
        // const originalProjects = data.filter(repo => !repo.fork); 
        // For now, we will include all public repos as requested "realtime" usually implies showing all activity.

        const projects = await Promise.all(data.map(async (repo) => {
            let imageUrl = "/assets/images/projects/devProjects/portfolio.png";
            let webpImage = "/assets/images/projects/devProjects/portfolio.webp";

            try {
                // Try to fetch README to parse for an image
                const readmeResponse = await fetch(`https://api.github.com/repos/${repo.owner.login}/${repo.name}/readme`, {
                    headers: { ...headers, 'Accept': 'application/vnd.github.v3.raw' }
                });

                if (readmeResponse.ok) {
                    const readmeContent = await readmeResponse.text();
                    // Basic regex to find the first image in markdown or HTML
                    const imageRegex = /!\[.*?\]\((.*?)\)|<img.*?src=["'](.*?)["']/;
                    const match = readmeContent.match(imageRegex);

                    if (match) {
                        let url = match[1] || match[2];
                        if (url && !url.startsWith('http')) {
                            // Convert relative path to raw github url
                            url = url.replace(/^(\.\/|\/)/, '');
                            url = `https://raw.githubusercontent.com/${repo.owner.login}/${repo.name}/${repo.default_branch}/${url}`;
                        }
                        if (url) {
                            imageUrl = url;
                            webpImage = url;
                        }
                    }
                }
            } catch (e) {
                console.warn(`Could not fetch README for ${repo.name}`);
            }

            let languages = [];
            try {
                const langResponse = await fetch(`https://api.github.com/repos/${repo.owner.login}/${repo.name}/languages`, { headers });
                if (langResponse.ok) {
                    const langData = await langResponse.json();
                    languages = Object.keys(langData);
                }
            } catch (e) {
                console.warn(`Could not fetch languages for ${repo.name}`);
            }

            const toolsList = new Set([
                ...(repo.language ? [repo.language] : []),
                ...(repo.topics || []),
                ...languages
            ]);

            return {
                title: repo.name,
                githubUrl: repo.html_url,
                demoUrl: repo.homepage || "",
                shortDescription: repo.description || "No description available.",
                longDescription: repo.description || "No description available.",
                tools: Array.from(toolsList),
                image: imageUrl,
                webpImage: webpImage,
                key: repo.id,
                isStarred: false // Changed since these are own repos
            };
        }));

        return projects;
    } catch (error) {
        console.error("Failed to fetch github projects:", error);
        return [];
    }
};
